// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 56612, offsets 239905:240050. Structure and names inferred from code, not screenshots.

let n = false;
function o() {
  n = true;
}
function a() {
  return !!n && ((n = false), true);
}
export { o as X, a as Z };
